/** Query keys for the issue-triage owner list (own file: read by several hooks). */
export const issueOwnerKeys = {
  all: ["issueOwners"] as const,
  list: () => [...issueOwnerKeys.all, "list"] as const,
};
